const PROFILE_PHOTOS_PATH = '/storage/v1/object/public/profile-photos/';
const PROFILE_PHOTOS_RENDER_PATH = '/storage/v1/render/image/public/profile-photos/';

/** Avatar display sizes — reserved if image transforms are enabled later. */
export const AVATAR_REQUEST_PX = {
  xxs: 48,
  xs: 72,
  sm: 80,
  md: 96,
  lg: 192,
  xl: 256,
};

/**
 * Supabase /render/image/ requires the image transformation add-on.
 * Keep false until enabled on the project — otherwise avatars 400/404.
 */
const PROFILE_PHOTO_TRANSFORMS_ENABLED = false;

export function isSupabaseProfilePhotoUrl(url) {
  if (!url || typeof url !== 'string') return false;
  return url.includes(PROFILE_PHOTOS_PATH) || url.includes(PROFILE_PHOTOS_RENDER_PATH);
}

/** Plain storage object URL — strips broken render paths and query params. */
export function normalizeProfilePhotoUrl(url) {
  if (!url || typeof url !== 'string') return null;
  let normalized = url.split('?')[0];
  if (normalized.includes(PROFILE_PHOTOS_RENDER_PATH)) {
    normalized = normalized.replace(
      '/storage/v1/render/image/public/',
      '/storage/v1/object/public/',
    );
  }
  return normalized;
}

function buildTransformUrl(baseObjectUrl, pixelSize) {
  const size = Math.max(24, Math.round(pixelSize));
  const renderUrl = baseObjectUrl.replace(
    '/storage/v1/object/public/',
    '/storage/v1/render/image/public/',
  );
  return `${renderUrl}?width=${size}&height=${size}&resize=cover&quality=80`;
}

/**
 * Profile photo URL for <img src>. Uses CSS slot sizing unless transforms are enabled.
 * External URLs pass through unchanged.
 */
export function getProfilePhotoUrl(url, pixelSize = 96) {
  if (!url) return null;
  if (!isSupabaseProfilePhotoUrl(url)) return url;

  const objectUrl = normalizeProfilePhotoUrl(url);
  if (!PROFILE_PHOTO_TRANSFORMS_ENABLED) {
    return objectUrl;
  }
  return buildTransformUrl(objectUrl, pixelSize);
}
